import { api } from "api/api";
import { AxiosError } from "axios";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class PessoaService implements BaseServiceCadastros<Pessoa> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null ) {
        return new Promise<Page>((resolve, reject): void => {

            let url = `/pessoa/pesquisar`;
            url += getFilters(filters)

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<Pessoa>((resolve, reject): void => {
            api
                .get(`/pessoa/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(pessoa: Pessoa) {
        return new Promise<Pessoa>((resolve, reject): void => {
            let url = `/pessoa/incluir`;
            api
                .post(url, JSON.stringify(pessoa))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(pessoa: Pessoa) {
        return new Promise<Pessoa>((resolve, reject): void => {
            api
                .put(`/pessoa/editar`, JSON.stringify(pessoa))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/pessoa/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    proximoCodigo(){
        return new Promise<string>((resolve, reject): void => {
            api
                .get(`/pessoa/proximoCodigo`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getFornecedores(): Promise<Pessoa[]> {
        return new Promise<Pessoa[]>((resolve, reject): void => {
            api
                .get(`/pessoa/fornecedores`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getTiposPessoa(): any[] {
        return [
            { label: 'Fornecedor', value: 'FORNECEDOR' },
            { label: 'Cliente', value: 'CLIENTE' },
            { label: 'Ambos', value: 'AMBOS'}
        ];
    }

    getTipoPessoa(value: string): any {
        return this.getTiposPessoa().find(tipo => tipo.value === value).label;
    }

    getTiposPessoaFilter() {
        return[
            {label: 'Fornecedor', value: 'F'},
            {label: 'Cliente', value: 'C'},
            {label: 'Ambos', value: 'A'}
        ]
    }

    getTiposDocumento(): any[] {
        return [
            { label: 'CPF', value: 'CPF' },
            { label: 'CNPJ', value: 'CNPJ' }
        ];
    }

    getIndicadoresInscricaoEstadual() {
        return [
            { label: "1 - Contribuinte do ICMS", value: "CONTRIBUINTE" },
            { label: "2 - Isento de inscrição estadual", value: "ISENTO" },
            { label: "9 - Não contribuinte", value: "NAO_CONTRIBUINTE" }
        ];
    }

    getTiposEnderecoFiscal() {
        return [
            { label: "Fiscal", value: "FISCAL" },
            { label: "Entrega", value: "ENTREGA" },
            { label: "Cobrança", value: "COBRANCA" }
        ];
    }

    


}

export default PessoaService;
